import { render, staticRenderFns } from "./ProfessionalInfoUpdate.vue?vue&type=template&id=85dea586"
import script from "./ProfessionalInfoUpdate.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports